(ns teamoesterreich.firebase.provider
  (:require
    [clojure.string :as str]
    [clojure.walk :as c-walk]
    [goog.object :as g]
    [teamoesterreich.config :as config]
    [teamoesterreich.firebase.storage-provider :as fst-provider]
    [teamoesterreich.store :as store]
    [teamoesterreich.util.helper :as h]
    [teamoesterreich.util.log :as log]
    ))


(def listener (atom {}))

(def ^js fs-store ((g/get js/firebase "firestore")))



(defn get-user-data [uid] (.then (.get (.doc fs-store (str "/users/" uid))) (fn [doc] (log/out (.data doc)))))



;; generic Listener
(defn remove-fs-to-store-list-listeners [path]
  (doseq [[r-path fs-unreg-fn] (deref listener)]
    (when (clojure.string/starts-with? r-path path)
      (when fs-unreg-fn (fs-unreg-fn))
      (swap! listener assoc r-path nil)
      )))

(defn only-maps [m]
  (reduce (fn [c [k v]] (if (map? v) (assoc c k v) c)) {} m))

(defn set-fs-to-store-list-listener [path store-path-list & [child-cb pre-store-fn]]
  (or (get (deref listener) path)
      (let [;_ (log/out "register listener for " path " exists? " (get (deref listener) path))
            cb-fn (fn [^js change]
                    (let [fs-obj (c-walk/keywordize-keys (js->clj (.data (.-doc change))))
                          fs-id (.-id (.-doc change))
                          fs-obj (if pre-store-fn (pre-store-fn fs-obj fs-id) fs-obj)
                          store-path-list (into [] (concat store-path-list [fs-id]))
                          ]
                      ;(log/out "fs-cb called " (= (.-type change) "removed") (.-type change) (clj->js change) path fs-id (clj->js store-path-list))
                      (if (= (.-type change) "removed")
                        (swap! store/app-state h/dissoc-in store-path-list)
                        (let [old (only-maps (get-in (deref store/app-state) store-path-list))
                              new (merge old fs-obj)]
                          ;(log/out "DEBUG before " (clj->js old))
                          ;todo prevent delete children ...
                          (swap! store/app-state assoc-in store-path-list new)
                          ;(log/out "DEBUG after " (clj->js new))
                          ))
                      (when child-cb (child-cb (str path "/" fs-id) store-path-list fs-id))))]
        (swap! listener assoc path (.onSnapshot (.collection fs-store path)
                                                (fn [^js snapshot] (.forEach (.docChanges snapshot) cb-fn)))))))


(defn register-shopping-listener [userId]
  (when userId
    (remove-fs-to-store-list-listeners (str "/users/" userId "/shopping"))
    (set-fs-to-store-list-listener (str "/users/" userId "/shopping")
                                   [:shopping])))

(defn register-actions-listener [userId]
  (when userId
    (remove-fs-to-store-list-listeners (str "/users/" userId "/actions"))
    (set-fs-to-store-list-listener (str "/users/" userId "/actions")
                                   [:actions])))

(defn register-messages-listener [userId]
  (when userId

    (remove-fs-to-store-list-listeners (str "/users/" userId "/messages"))
    (set-fs-to-store-list-listener (str "/users/" userId "/messages")
                                   [:messages])))

(defn register-eventList-listener [userId]
  (when userId
    (remove-fs-to-store-list-listeners (str "/users/" userId "/event-list"))
    (set-fs-to-store-list-listener (str "/users/" userId "/event-list")
                                   [:event-list])))

(defn register-news-listener [userId]
  (when userId
    (remove-fs-to-store-list-listeners "/news")
    (set-fs-to-store-list-listener "/news"
                                   [:news])))


(defn register-blog-listener []
  (when (= config/CLIENT "tb")
    ;(log/debug "REGISTER BLOG LISTENER #######################################################################")
    (remove-fs-to-store-list-listeners "/blog")
    (set-fs-to-store-list-listener "/blog"
                                   [:blog])))



(defn register-global-warnings-listener []
  ;(log/debug "REGISTER GLOBAL WARNINGS LISTENER #######################################################################")
  (remove-fs-to-store-list-listeners "/warnings")
  (set-fs-to-store-list-listener "/warnings"
                                 [:warnings]))


(defn register-notification-listener [userId]
  (when userId
    (remove-fs-to-store-list-listeners "/notifications")
    (set-fs-to-store-list-listener (str "/users/" userId "/notifications")
                                   [:notifications])))

(defn register-user-documents-listener [userId]
  (when userId
    (remove-fs-to-store-list-listeners "/documents")
    (set-fs-to-store-list-listener (str "/users/" userId "/documents")
                                   [:user-documents])))

(defn register-devices-listener [userId]
  (when userId
    (remove-fs-to-store-list-listeners "/devices")
    (set-fs-to-store-list-listener (str "/users/" userId "/devices")
                                   [:user-devices])))


(defn register-crowdtasker-listener [userId]
  (when userId
    (remove-fs-to-store-list-listeners "/crowdtasker")
    (set-fs-to-store-list-listener "/crowdtasker"
                                   [:crowdtasker]
                                   (fn [path store-path-list fs-id]
                                     (set-fs-to-store-list-listener (str path "/tasks")
                                                                    (into [] (concat store-path-list [:tasks]))
                                                                    (fn [path store-path-list fs-id]
                                                                      (set-fs-to-store-list-listener (str path "/questions")
                                                                                                     (into [] (concat store-path-list [:questions]))
                                                                                                     (fn [path store-path-list fs-id]
                                                                                                       (set-fs-to-store-list-listener (str path "/answer-options")
                                                                                                                                      (into [] (concat store-path-list [:answer-options])))))))))))
(defn register-questionnaire-listener [userId]
  (when userId
    (remove-fs-to-store-list-listeners "/questionnaires")
    (set-fs-to-store-list-listener "/questionnaires"
                                   [:questionnaires]
                                   (fn [path store-path-list fs-id]
                                     (set-fs-to-store-list-listener (str path "/questions")
                                                                    (into [] (concat store-path-list [:questions]))
                                                                    (fn [path store-path-list fs-id]
                                                                      (set-fs-to-store-list-listener (str path "/answer-options")
                                                                                                     (into [] (concat store-path-list [:answer-options]))
                                                                                                     (fn [path store-path-list fs-id]
                                                                                                       (set-fs-to-store-list-listener (str path "/triggers")
                                                                                                                                      (into [] (concat store-path-list [:triggers])))))))))))
(defn register-location-listener [userId]
  (when userId
    (remove-fs-to-store-list-listeners (str "/users/" userId "/locations"))
    (set-fs-to-store-list-listener (str "/users/" userId "/locations")
                                   [:locations]
                                   (fn [path store-path-list fs-id]
                                     ;warnings
                                     (set-fs-to-store-list-listener (str path "/warnings")
                                                                    (into [] (concat store-path-list [:warnings])))
                                     ;questionnaires
                                     (set-fs-to-store-list-listener (str path "/questionnaires")
                                                                    (into [] (concat store-path-list [:questionnaires]))
                                                                    (fn [path store-path-list fs-id]
                                                                      (set-fs-to-store-list-listener (str path "/questions")
                                                                                                     (into [] (concat store-path-list [:questions]))
                                                                                                     (fn [path store-path-list fs-id]
                                                                                                       (set-fs-to-store-list-listener (str path "/answers")
                                                                                                                                      (into [] (concat store-path-list [:answers]))))
                                                                                                     )))
                                     )
                                   (fn [fs-obj fs-id]
                                     ;(log/out "has location-picture-path " (:location-picture-path fs-obj))
                                     (fst-provider/get-download-url (:location-picture-path fs-obj)
                                                                    (fn [dwn-url]
                                                                      (log/out "store callback " (:location-picture-path fs-obj))
                                                                      (swap! store/app-state assoc-in [:locations fs-id :location-picture-path-fst] dwn-url)))
                                     fs-obj))))



(defn register-user-questionnaire-listener [userId]
  (when userId
    (remove-fs-to-store-list-listeners (str "/users/" userId "/questionnaires"))
    (set-fs-to-store-list-listener (str "/users/" userId "/questionnaires")
                                   [:user-questionnaires]
                                   (fn [path store-path-list fs-id]
                                     (set-fs-to-store-list-listener (str path "/questions")
                                                                    (into [] (concat store-path-list [:questions]))
                                                                    (fn [path store-path-list fs-id]
                                                                      (set-fs-to-store-list-listener (str path "/answers")
                                                                                                     (into [] (concat store-path-list [:answers]))))
                                                                    )))))



;(register-location-listener)
;

#_(log/out (clj->js (into {} (filter (fn [[uuid q]] (and (:appearance-self q)
                                                         (:active q)
                                                         (:published q)))
                                     (:questionnaires (deref store/app-state))))))
#_(log/out (clj->js (:questionnaires (deref store/app-state))))
#_(log/out (clj->js (:actual-user (deref store/app-state))))

(defn get-uid []
  (when-let [auth (js/firebase.auth)]
    (when-let [user (.-currentUser auth)]
      (.-uid user))))

;;; Listener


;;; Store updater

(def !user-data-syncer (atom nil))

(defn update-actual-user [doc]
  (let [data (js->clj (.data doc) {:keywordize-keys true})
        new-state (swap! store/app-state
                         (fn [state]
                           (let [old-user (:actual-user state)
                                 obj (merge old-user data)]
                             (log/out "Actual User Listener fired!!!" doc #_(clj->js obj) #_(:portrait-path obj))
                             (cond-> state
                                     true (assoc :actual-user obj)
                                     (:browser-intro-done obj) (assoc-in [:state :intro] 10)))))
        obj (:actual-user new-state)]

    (when (:portrait-path obj)
      (fst-provider/get-download-url (:portrait-path obj)
                                     (fn [dwn-url]
                                       (log/out "store callback portrait " (:portrait-path obj) dwn-url)
                                       (swap! store/app-state assoc-in [:actual-user :portrait-path-fst] dwn-url))))
    ))

(defn set-user-data-syncer [userId]
  (log/out "set-user-data-syncer" userId)
  (when-let [unsubscribe @!user-data-syncer] (unsubscribe))
  (reset! !user-data-syncer
          (.onSnapshot (.doc fs-store (str "/users/" userId))
                       (fn [^js doc]
                         (update-actual-user doc)
                         (when-not (.. doc -metadata -fromCache)
                           (store/update-loading :user))))))

(defn load-user [userId]
  (log/out "load-user" userId)
  (if userId
    (.then (.get (.doc fs-store (str "/users/" userId)))
           (fn [doc]
             (update-actual-user doc)
             (store/update-loading :user)))
    (js/Promise. (fn [resolve] (resolve nil)))))

(defn load-documents [userId]
  (log/out "load-documents" userId)
  (if userId
    (.then (.get (.collection fs-store (str "/users/" userId "/documents")))
           (fn [col]
             (doseq [doc ^js (.-docs col)]
               (swap! store/app-state assoc-in [:user-documents (.-id doc)] (c-walk/keywordize-keys (js->clj (.data doc)))))
             (store/update-loading :documents)))
    (js/Promise. (fn [resolve] (resolve nil)))))


;(update-fs-user-swap-val :languages {:en "good"})

(defn update-fs-user [data]
  (let [uid (get-uid)
        _ (log/out "update-fs-user " (str "/users/" uid) (clj->js data))
        doc (.doc fs-store (str "/users/" uid))]
    (.set doc (clj->js data) (clj->js {:merge true}))))

(defn update-fs-device [data]
  (let [uid (get-uid)
        _ (log/out "update-fs-device " (str "/users/" uid "/devices/browser"))
        doc (.doc fs-store (str "/users/" uid "/devices/browser"))]
    (.set doc data (clj->js {:merge true}))))


(defn create-fs-location [data success-fn]
  (let [uid (get-uid)
        _ (log/out "create-fs-location " (str "/users/" uid "/locations"))
        collection (.collection fs-store (str "/users/" uid "/locations"))
        res (.then (.add collection (clj->js data))
                   (fn [reference] (success-fn (.-id reference))))]
    (log/out "created :" res)
    res))

(defn update-fs-location [locationId data]
  (let [uid (get-uid)
        _ (log/out "update-fs-location " (str "/users/" uid "/locations/" locationId))
        doc (.doc fs-store (str "/users/" uid "/locations/" locationId))]
    (.set doc (clj->js data) (clj->js {:merge true}))))

;(swap! vstate/app-state h/dissoc-in [:locations "WMT4trFXC2IMM0LXZuAX"])
;(get-in (deref vstate/app-state) [:locations "D2WHSOoYklnffutmCDK1"])

(defn delete-fs-location [locationId]
  (let [uid (get-uid)
        path (str "/users/" uid "/locations/" locationId)
        doc (.doc fs-store path)]
    (log/out "_drop-location-item " locationId " " path)
    (.delete doc)
    (.delete doc)
    (swap! store/app-state h/dissoc-in [:locations locationId])
    (log/out "_drop-location-item " (clj->js (:locations (deref store/app-state))))
    ))

(defn update-fs-user-questionnaire-response [questionnaireId data]
  (let [uid (get-uid)
        path (str "/users/" uid "/questionnaires/" questionnaireId)
        _ (log/out "update-fs-questionnaire-response " path)
        doc (.doc fs-store path)]
    (.set doc (clj->js data) (clj->js {:merge true}))))

(defn update-fs-user-questionnaire-question-response [questionnaireId questionId data]
  (let [uid (get-uid)
        path (str "/users/" uid "/questionnaires/" questionnaireId "/questions/" questionId)
        _ (log/out "update-fs-questionnaire-question-response " path)
        doc (.doc fs-store path)]
    (.set doc (clj->js data) (clj->js {:merge true}))))

(defn update-fs-user-questionnaire-answer [questionnaireId questionId answerOptionId data]
  (let [uid (get-uid)
        path (str "/users/" uid "/questionnaires/" questionnaireId "/questions/" questionId "/answers/" answerOptionId)
        doc (.doc fs-store path)
        data (if (:__answer-option data)
               (assoc data :answer-option (.doc fs-store (:__answer-option data)))
               data)
        _ (log/out "update-fs-questionnaire-answer " path (clj->js data))
        ]
    (.set doc (clj->js data) (clj->js {:merge true}))))

(defn update-fs-user-location-questionnaire-response [locationId questionnaireId data]
  (let [uid (get-uid)
        path (str "/users/" uid "/locations/" locationId "/questionnaires/" questionnaireId)
        _ (log/out "update-fs-user-location-questionnaire-response " path)
        doc (.doc fs-store path)]
    (.set doc (clj->js data) (clj->js {:merge true}))))

(defn update-fs-user-location-questionnaire-question-response [locationId questionnaireId questionId data]
  (let [uid (get-uid)
        path (str "/users/" uid "/locations/" locationId "/questionnaires/" questionnaireId "/questions/" questionId)
        _ (log/out "update-fs-user-location-questionnaire-question-response " path)
        doc (.doc fs-store path)]
    (.set doc (clj->js data) (clj->js {:merge true}))))

(defn update-fs-user-location-questionnaire-answer [locationId questionnaireId questionId answerOptionId data]
  (let [uid (get-uid)
        path (str "/users/" uid "/locations/" locationId "/questionnaires/" questionnaireId "/questions/" questionId "/answers/" answerOptionId)
        doc (.doc fs-store path)
        data (if (:__answer-option data)
               (assoc data :answer-option (.doc fs-store (:__answer-option data)))
               data)
        _ (log/out "update-fs-user-location-questionnaire-answer " path (clj->js data))
        ]
    (.set doc (clj->js data) (clj->js {:merge true}))))



(defn update-fs-user-crowdtasker-response [crowdtaskerId data]
  (let [uid (get-uid)
        path (str "/users/" uid "/crowdtasker/" crowdtaskerId)
        _ (log/out "update-fs-crowdtasker-response " path)
        doc (.doc fs-store path)]
    (.set doc (clj->js data) (clj->js {:merge true}))))


(defonce last-shopping (atom {}))
;(.-path (:reference (deref last-shopping)))

(defn _add-shopping-item [itemId data]
  (reset! last-shopping data)
  (let [uid (get-uid)
        path (str "/users/" uid "/shopping/" itemId)
        data (if (:triggerId data) (assoc data :trigger-reference (.doc fs-store (str (:aot-path data)))) data)
        data (if (:locationId data) (assoc data :location-reference (.doc fs-store (str "/users/" uid "/locations/" (:locationId data)))) data)
        data (assoc data :quantity (js/parseFloat (:quantity data)))
        _ (log/out "_add-shopping-item " path (clj->js data))
        doc (.doc fs-store path)
        ]
    (.set doc (clj->js data) (clj->js {:merge true}))
    ))

(defn _add-action-list-item [itemId data]
  (let [uid (get-uid)
        path (str "/users/" uid "/actions/" itemId)
        data (if (:triggerId data) (assoc data :trigger-reference (.doc fs-store (str (.-path (:reference data)) "/triggers/" (:triggerId data)))) data)
        data (if (:locationId data) (assoc data :location-reference (.doc fs-store (str "/users/" uid "/locations/" (:locationId data)))) data)
        data (assoc data :quantity (js/parseFloat (:quantity data)))
        _ (log/out "_add-action-item " path (clj->js data))
        doc (.doc fs-store path)
        ]
    (.set doc (clj->js data) (clj->js {:merge true}))
    ))

;(h/dissoc-in {:1 {:1 1 :2 2} :2 2 :3 3} [:1 :2])

(defn _drop-shopping-item [itemId]
  (let [uid (get-uid)
        path (str "/users/" uid "/shopping/" itemId)
        doc (.doc fs-store path)]
    (log/out "_drop-shopping-item " path)
    (.delete doc)
    (swap! store/app-state h/dissoc-in [:shopping itemId])
    ))

(defn _drop-action-list-item [itemId]
  (let [uid (get-uid)
        path (str "/users/" uid "/actions/" itemId)
        doc (.doc fs-store path)]
    (.delete doc)
    (swap! store/app-state h/dissoc-in [:actions itemId])
    ))

(defn _drop-notification-item [itemId]
  (let [uid (get-uid)
        path (str "/users/" uid "/notifications/" itemId)
        doc (.doc fs-store path)]
    (.delete doc)
    (swap! store/app-state h/dissoc-in [:notifications itemId])
    ))


(defn update-fs-user-document [uuid data]
  (log/debug "_add-user-document" uuid data)
  (let [uid (get-uid)
        path (str "/users/" uid "/documents/" uuid)
        doc (.doc fs-store path)
        ]
    (.set doc (clj->js data) (clj->js {:merge true}))
    ))


(defn _add-user-document [uuid data]
  (log/debug "_add-user-document" uuid data)
  (let [uid (get-uid)
        path (str "/users/" uid "/documents/" uuid)
        doc (.doc fs-store path)
        ]
    (.set doc (clj->js data) (clj->js {:merge true}))
    ))



(defn get-location-ref [locationId]
  (let [userId (get-uid)]
    (.doc fs-store (str "/users/" userId "/locations/" locationId))))
;(update-fs-user {:fav-location (get-location-ref "JpTPs5PsJ8dzvYf0zlV1")})

(defn get-fav-locationId
  ([]
   (get-fav-locationId (:actual-user (deref store/app-state))))
  ([user]
   ; FIXME: should be using [:main_address :location-ref] since 2021-07
   (let [loc-ref (:fav-location user)]
     (when loc-ref (last (str/split (.-path loc-ref) #"/"))))))
;(get-fav-locationId)

(defn has-required-fields? [user-data]
  (and (some? (get-fav-locationId user-data))
       (some? (:birthday user-data))))

(defn promise-has-required-fields? [userId]
  (-> (.get (.doc fs-store (str "/users/" userId)))
      (.then (fn [^js doc]
               (let [data (js->clj (.data doc) {:keywordize-keys true})]
                 (has-required-fields? data))))))

(defn connect-fs [userId]
  (load-user userId)
  (set-user-data-syncer userId)
  (register-blog-listener)
  (register-news-listener userId)
  (register-user-documents-listener userId)
  (register-messages-listener userId)
  (register-eventList-listener userId)
  (register-location-listener userId)
  (register-devices-listener userId)
  (register-shopping-listener userId)
  (register-actions-listener userId)
  (register-notification-listener userId)
  (register-questionnaire-listener userId)
  (register-user-questionnaire-listener userId)
  (register-global-warnings-listener)
  ;(register-crowdtasker-listener)

  (swap! store/app-state assoc :connected true)
  )


;actions

(defn add-shopping-item [itemId item-obj] (_add-shopping-item itemId item-obj))
(defn add-action-list-item [itemId item-obj] (_add-action-list-item itemId item-obj))
(defn drop-shopping-item [itemId] (_drop-shopping-item itemId))
(defn drop-action-list-item [itemId] (_drop-action-list-item itemId))
(defn drop-notification-item [itemId] (_drop-notification-item itemId))


(defn set-user-fav-location [locationId] (update-fs-user {:fav-location (get-location-ref locationId)}))

(defn edit-location [locationId loc-obj] (update-fs-location locationId loc-obj))
(defn create-location [loc-obj success-fn] (create-fs-location loc-obj success-fn))
(defn drop-location [locationId] (delete-fs-location locationId))

(defn set-user-crowdtasker-response [crowdtaskerId data] (update-fs-user-crowdtasker-response crowdtaskerId data))

(defn set-user-questionnaire-response [questionnaireId data] (update-fs-user-questionnaire-response questionnaireId data))
(defn set-user-questionnaire-question-response [questionnaireId questionId data] (update-fs-user-questionnaire-question-response questionnaireId questionId data))
(defn set-user-questionnaire-answer [questionnaireId questionId answerOptionId data] (update-fs-user-questionnaire-answer questionnaireId questionId answerOptionId data))

(defn set-user-location-questionnaire-response [locationId questionnaireId data] (update-fs-user-location-questionnaire-response locationId questionnaireId data))
(defn set-user-location-questionnaire-question-response [locationId questionnaireId questionId data] (update-fs-user-location-questionnaire-question-response locationId questionnaireId questionId data))
(defn set-user-location-questionnaire-answer [locationId questionnaireId questionId answerOptionId data] (update-fs-user-location-questionnaire-answer locationId questionnaireId questionId answerOptionId data))

(defn add-user-document [itemId item-obj] (_add-user-document itemId item-obj))
(defn set-user-document [itemId item-obj] (update-fs-user-document itemId item-obj))



;(connect-fs)
;(log/out session)
;(log/out (clj->js @vstate/app-state))

